import React, {  useEffect, useState,useRef,useContext  } from "react";

import { useNavigate,Link,useParams  } from 'react-router-dom';

import Context from '../../../context/context';
import queryString from 'query-string';
import helpersFunction from "../../../_helpers/helpersFunction";

import mollie_functions from "./functions";
const config = require("../../../_helpers/configServizi"); 




export default function Ok() {
    
    const query = queryString.parse(window.location.search);
    
 

    const context = useContext(Context)
    const navigate = useNavigate() 

     
    
    useEffect(() => {

        try{
            console.log("PAUYMENT CHAECK",query)

            const domain = window.location.hostname
            
           var internal_trxid = query.internal_trxid
            mollie_functions.checkTransactionStatus({ clickid: localStorage.getItem('trackerId'), domain: domain, payment_company: config.servizi[domain].payment_company, internal_trxid: internal_trxid })
                .then(response=>{
                   
                    const contenuto = helpersFunction.contenuto_popop_pagamento(response.message)
                    helpersFunction.showPopupgenerico("blocked",context,contenuto)

                    if(response.message == "success"){
                         setTimeout(function(){ 
                        context.Socket.emit('chat', context.messaggioPending);
                        context.setMessaggioPending(null);
                        window.location.replace("/chats")  }, 3000);
                    }
                   
    
                }).catch(err=>{
                    const contenuto = helpersFunction.contenuto_popop_pagamento("generico")
                    helpersFunction.showPopupgenerico("blocked",context,contenuto)
                    console.log(err)
                })
               
        }
        catch(e){
            helpersFunction.logToBackend("error", "ERRORACCIO MOLLIE"+e)
        }
       
      
       
     },[])
    

    return (<div className="all-container bg-light pianiAbbonamentoPage">
               
            </div>
    )
   


}